module.exports = __webpack_public_path__ + "static/media/1022299.6950bbc5.jpg";